/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function initializeFilterTransformation() {
        var doTransform = function (selectNode) {
            var filterContainer = selectNode.closest('.collection-filter');
            if (filterContainer.classList.contains('transformed')) {
                return;
            }

            var filterButton = document.createElement('button');
            filterButton.type = 'button';
            filterButton.className = 'btn-filter';
            filterButton.innerHTML = `
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_197_120)">
                        <path d="M6 8C6 7.86739 6.05268 7.74021 6.14645 7.64645C6.24021 7.55268 6.36739 7.5 6.5 7.5H9.5C9.63261 7.5 9.75979 7.55268 9.85355 7.64645C9.94732 7.74021 10 7.86739 10 8C10 8.13261 9.94732 8.25979 9.85355 8.35355C9.75979 8.44732 9.63261 8.5 9.5 8.5H6.5C6.36739 8.5 6.24021 8.44732 6.14645 8.35355C6.05268 8.25979 6 8.13261 6 8ZM4 5C4 4.86739 4.05268 4.74021 4.14645 4.64645C4.24021 4.55268 4.36739 4.5 4.5 4.5H11.5C11.6326 4.5 11.7598 4.55268 11.8536 4.64645C11.9473 4.74021 12 4.86739 12 5C12 5.13261 11.9473 5.25979 11.8536 5.35355C11.7598 5.44732 11.6326 5.5 11.5 5.5H4.5C4.36739 5.5 4.24021 5.44732 4.14645 5.35355C4.05268 5.25979 4 5.13261 4 5ZM2 2C2 1.86739 2.05268 1.74021 2.14645 1.64645C2.24021 1.55268 2.36739 1.5 2.5 1.5H13.5C13.6326 1.5 13.7598 1.55268 13.8536 1.64645C13.9473 1.74021 14 1.86739 14 2C14 2.13261 13.9473 2.25979 13.8536 2.35355C13.7598 2.44732 13.6326 2.5 13.5 2.5H2.5C2.36739 2.5 2.24021 2.44732 2.14645 2.35355C2.05268 2.25979 2 2.13261 2 2Z" fill="white"/>
                    </g>
                    <defs>
                        <filter id="filter0_d_197_120" x="-1" y="0.5" width="18" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="2"/>
                            <feGaussianBlur stdDeviation="1.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_197_120"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_197_120" result="shape"/>
                        </filter>
                    </defs>
                </svg>
                <span>FILTER ${filterContainer.querySelector('.collection-filter__item--count').innerHTML.match(/\d+/)[0]} ITEMS</span>
                <span class="arrow-right"></span>
            `;

            filterContainer.insertAdjacentElement('beforeend', filterButton);
            filterContainer.classList.add('transformed');
            filterButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                filterContainer.querySelector('button.js-drawer-open-collection-filters').click();
            });

            Mojito.utils.waitForElement('#FilterDrawer .drawer__inner', function (element) {
                element.insertAdjacentElement('afterbegin', selectNode);
            });
        };

        Mojito.utils.waitForElement('.collection-filter__sort-container select', doTransform);
    }

    function triggerFilterTransformation() {
        if (/^\/collections\//.test(location.pathname) && Math.min(window.innerWidth, window.innerHeight) < 768 && 'ontouchstart' in window) {
            Mojito.utils.domReady(initializeFilterTransformation);
        }
    }

    triggerFilterTransformation();
})();
